import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../utils/routes';

/**
 * NotFoundPage - 404 page for undefined routes
 */
export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="not-found-page" style={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', padding: '40px 20px' }}>
      <div style={{ maxWidth: '600px' }}>
        <h1 style={{ fontSize: '96px', fontWeight: 'bold', color: '#ff6b6b', margin: '0 0 20px 0' }}>404</h1>
        <h2 style={{ fontSize: '28px', fontWeight: 'bold', margin: '0 0 16px 0' }}>Page Not Found</h2>
        <p style={{ fontSize: '16px', color: '#666', margin: '0 0 32px 0' }}>
          The page you're looking for doesn't exist or has been moved.
        </p>
        <button
          onClick={() => navigate(ROUTES.HOME)}
          style={{
            padding: '12px 32px',
            fontSize: '16px',
            fontWeight: '600',
            backgroundColor: '#ff6b6b',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            transition: 'background-color 0.3s ease',
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#ff5252'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#ff6b6b'}
        >
          Go to Home
        </button>
      </div>
    </div>
  );
}
